"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthInfo = void 0;
const Fetch_1 = require("../../Fetch");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const Config_1 = require("../../Config");
const getAuthInfo = async ({ jwtToken }) => {
    const jwtDecode = (0, jwt_decode_1.default)(jwtToken);
    return (0, Fetch_1.fetchToJson)(`${(0, Config_1.getConfigValue)('COMMON_API_BASE_PATH')}/fce/auth.php?method=usr`, false, { token: jwtToken })
        .then(response => ({
        lauList: response.data,
        userInfo: response.uzivatel,
        jwtExpiration: new Date(jwtDecode.exp * 1000)
    }));
};
exports.getAuthInfo = getAuthInfo;
